import { createServerFn } from "@tanstack/react-start";
import { createClient } from "@supabase/supabase-js";
import type { Calibration } from "./valuation-calibration";

/** Publik läsning av nattens kalibrering. Ingen inloggning, inga persondata. */
export const getCalibrations = createServerFn({ method: "GET" }).handler(
  async (): Promise<Calibration[]> => {
    const supabase = createClient(
      process.env["SUPABASE_URL"]!,
      process.env["SUPABASE_PUBLISHABLE_KEY"]!,
      { auth: { storage: undefined, persistSession: false, autoRefreshToken: false } },
    );

    const { data, error } = await supabase
      .from("valuation_calibration")
      .select("category, factor, sample_size, mape, median_ratio, computed_at");

    if (error || !data) return [];

    return data
      .filter((r) => r.category === "husbil" || r.category === "husvagn")
      .map((r) => ({
        category: r.category as Calibration["category"],
        factor: Number(r.factor),
        sampleSize: r.sample_size,
        mape: Number(r.mape),
        medianRatio: Number(r.median_ratio),
        computedAt: r.computed_at,
      }));
  },
);
